import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSimpleButton from '@/components/AppSimpleButton.vue';
import { utcDateTimeToLocal } from '@/utils/dateTime';
import SchoolDialog from '../SchoolList/script-dialog';

var SchoolDetail = /*#__PURE__*/function (_mixins) {
  _inherits(SchoolDetail, _mixins);

  var _super = _createSuper(SchoolDetail);

  function SchoolDetail() {
    var _this;

    _classCallCheck(this, SchoolDetail);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '学校管理'
    }, {
      text: '学校',
      to: {
        name: 'SchoolList'
      }
    }];
    _this.disableConfirm = false;
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    _this.loading = false;
    _this.dealers = [];
    _this.headers = [{
      text: '姓名',
      value: 'realname',
      sortable: false
    }, {
      text: '手机号',
      value: 'user.phone',
      sortable: false
    }, {
      text: '店铺名称',
      value: 'storeName',
      sortable: false
    }, {
      text: '店铺电话',
      value: 'storePhone',
      sortable: false
    }];
    _this.options = {
      sortBy: ['realname'],
      sortDesc: [true]
    };
    _this.schoolId = '';
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    return _this;
  }

  _createClass(SchoolDetail, [{
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$targetSchool, _this$targetSchool2;

        var id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.onResize();
                id = this.$route.params.id;
                this.schoolId = id;
                _context.next = 5;
                return this.getSchoolById(Number(this.schoolId));

              case 5:
                this.targetSchool = _context.sent;
                this.dealers = (_this$targetSchool = this.targetSchool) === null || _this$targetSchool === void 0 ? void 0 : _this$targetSchool.dealers;
                this.breadcrumbs.push({
                  text: "".concat((_this$targetSchool2 = this.targetSchool) === null || _this$targetSchool2 === void 0 ? void 0 : _this$targetSchool2.name)
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "deleteConfirm",
    value: function () {
      var _deleteConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.deleteSchoolById();

              case 2:
                this.$router.push({
                  name: 'SchoolList'
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteConfirm() {
        return _deleteConfirm.apply(this, arguments);
      }

      return deleteConfirm;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
    }
  }, {
    key: "exportHandler",
    value: function exportHandler() {}
  }]);

  return SchoolDetail;
}(mixins(SchoolDialog));

SchoolDetail = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleButton: AppSimpleButton
  }
})], SchoolDetail);
export default SchoolDetail;